import styled from "styled-components";

export const TableMainContainer = styled.div`
  height: calc(100vh - 19.8rem);
  max-height: calc(100vh - 20.7rem);
  overflow-y: auto;
  width: auto;
  min-width: 100px;
  background: var(--white);
`;

export const Table = styled.table`
  width: 100%;
  position: relative;
  text-align: left;
  border-collapse: collapse;
`;

export const TableRow = styled.tr<{
  isActive?: boolean;
}>`
  display: grid;
  grid-template-columns: 1.4fr repeat(4, 1fr);
  justify-content: flex-start;
  align-items: center;
`;

export const TableCell = styled.td<{ hideColumn?: boolean }>`
  font-size: 16px;
  font-weight: 300;
  line-height: 19px;
  letter-spacing: 0.14024999737739563px;
  text-align: left;
  flex: 1%;
  display: ${({ hideColumn }) => (hideColumn ? "none" : "flex")};
`;

export const TableHead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 1;
  background: white;
`;

export const TableHeadRow = styled(TableRow)`
  border-bottom: 0.75px solid rgba(0, 0, 0, 0.13);
  margin: 0px;
`;

export const TableHeadCell = styled.th<{ hideColumn?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  padding-bottom: 4px;
  color: rgba(0, 0, 0, 0.54);
  flex: 1%;
  display: ${({ hideColumn }) => (hideColumn ? "none" : "block")};
  position: sticky;
  top: 0;
`;

export const ActionButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  width: 100px;
  background: #ffffff;
  border: none;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 39px;
  cursor: pointer;
`;

export const OpenLoader = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 20px;
  border: 1px solid var(--btn-border);
  padding: 4px 32px;
`;
